import { Injectable, signal } from "@angular/core";

/**
 * Coordinates return navigation from election sub-pages (e.g. manual candidate entry)
 * back to the admin election detail view with a fresh load.
 */
@Injectable({ providedIn: "root" })
export class ElectionAdminReturnStore {
    private readonly returnToElectionId = signal<number | null>(null);

    pendingReturnToElection(): number | null {
        return this.returnToElectionId();
    }

    scheduleReturnToElection(electionId: number): void {
        if (!electionId || !Number.isFinite(electionId)) {
            return;
        }
        this.returnToElectionId.set(electionId);
    }

    clearReturnToElection(): void {
        if (this.returnToElectionId() == null) {
            return;
        }
        this.returnToElectionId.set(null);
    }
}
